<template>

  <DialogFrame v-if="isDialogOpen" @click-background="onClose">
    <button v-if="isUserOpen || getPreviousRoute()" class="close" @click="onClose">×</button>
    <LoginInput :title="title" :requestLogin="requestLogin" ref="login" @user-logined="onUserLogin" @on-click-link="close"/>
  </DialogFrame>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { Ref } from "vue-property-decorator";
import RootVue from "@/RootVue.vue";
import { getPreviousRoute, LOGIN_PAGE } from "@/router";
import DialogFrame from "./DialogFrame.vue";
import LoginInput from "../LoginInput.vue";
import { FMRequestLogin } from '@/interface/kiwi/ForkstyleMessage';

@Options({ components: { DialogFrame, LoginInput } })
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  //mounted前のlifesycleだと初期化前で使用できない点に注意
  @Ref() readonly login = null as any as LoginInput;

  //任意のページで、ユーザの意思でダイアログを表示した場合にtrueにする。（ログインURLに遷移した場合も含む）
  isUserOpen: boolean = false;

  requestLogin:FMRequestLogin|null|undefined = null;
  
  get getPreviousRoute(){
    return getPreviousRoute;
  }

  get title(){
    return this.isUserOpen ? '' : 'このページはログインが必要です'
  }

  open(data?:FMRequestLogin) {
    this.isUserOpen = true;
    this.requestLogin = data
  }

  close() {
    this.isUserOpen = false;
    this.login?.clearInput();//isDialogOpenによりv-if=falseとなるタイミングがあるので.?を付与
  }

  get isDialogOpen(): boolean {
    //ユーザがダイアログを表示した場合、もしくは、ログインが必要なページ（かつ未ログイン）、のどちらかでダイアログを開く
    return this.isUserOpen || !!(this.$route.meta && this.$route.meta.requiresAuth && this.$root.account.isLoaded && !this.$root.account.isLogin);
  }
  
  onClose() {
    if(this.isUserOpen){
      this.close();
    }else{
      this.close();
      if(getPreviousRoute()){
        this.$router.back();
      }
    }
  }

  onUserLogin() {
    //ログインページの場合
    if(this.$router.currentRoute.value.path === LOGIN_PAGE){
      this.$router.push("/");
    }
    this.close();
  }
}
</script>